import { cleanInput } from '@exodus/basic-utils';
import { useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
import useFromAmount from './use-from-amount.js';
import useFromAsset from './use-from-asset.js';
import { useMemo } from 'react';
const useFromFiatAmount = () => {
    const selectors = useSelectors();
    const [fromAsset] = useFromAsset();
    const [fromAmount, setFromAmount] = useFromAmount();
    const fiat = useSelector(selectors.locale.currencyUnitType);
    const getAssetConversion = useSelector(selectors.fiatBalances.createAssetConversion(fromAsset.name));
    const getFiatConversion = useSelector(selectors.fiatBalances.createConversion);
    const fromFiatAmount = useMemo(() => getAssetConversion(fromAmount), [fromAmount, getAssetConversion]);
    const setFromFiatAmount = (value) => {
        const decimals = fiat.defaultUnit.power;
        const cleanedValue = cleanInput(value, decimals);
        const fiatValue = fiat.defaultUnit(cleanedValue);
        const cryptoValue = getFiatConversion(fromAsset.name)(fiatValue);
        setFromAmount(cryptoValue);
    };
    return [fromFiatAmount, setFromFiatAmount];
};
export default useFromFiatAmount;
